import React, { useState, useEffect, useRef, MouseEvent } from "react";
import Stickyfill from "stickyfilljs";
import { Caret } from "@cmsgov/ds-medicare-gov";
import { useTranslate, safeMatches } from "../helpers";

const FloatNav: React.FunctionComponent = ({ children }) => {
  const t = useTranslate();
  const [isVisible, setIsVisible] = useState(false);
  const stickyElem = useRef<HTMLDivElement>(null);

  const toggleVisibility = (): void => {
    setIsVisible(!isVisible);
  };

  const hideAfterNavigation = (
    event: MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ): void => {
    if (event.target && safeMatches(event.target as HTMLElement, "a")) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    if (stickyElem.current) {
      Stickyfill.addOne(stickyElem.current);
    }
  }, []);

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className={`FloatNavBackground${isVisible ? "" : " hidden"}`}
        onKeyDown={(event): void => {
          if (event.keyCode === 13 && isVisible) {
            toggleVisibility();
          }
        }}
        onClick={(): void => {
          if (isVisible) {
            toggleVisibility();
          }
        }}
      />
      <div className="FloatNav mct-hide-print">
        <nav
          ref={stickyElem}
          className={`FloatNav__content${isVisible ? "" : " hidden"}`}
        >
          {React.Children.map(
            children as React.ReactElement[],
            (child: React.ReactElement) => {
              if (React.isValidElement(child)) {
                return React.cloneElement(child as React.ReactElement, {
                  hideAfterNavigation,
                });
              }

              return <></>;
            }
          )}
        </nav>
        <div className="FloatNav__footer">
          <hr className="ds-u-fill--gray-light" />
          <button onClick={toggleVisibility}>
            {isVisible
              ? t("plan_details.navigation.close_navigation")
              : t("plan_details.navigation.navigate_page")}
            <Caret up={!isVisible} />
          </button>
        </div>
      </div>
    </>
  );
};

export default FloatNav;
